import { Injectable } from '@angular/core';
import * as moment from 'moment';
import {HttpInterceptor2} from "./HttpInterceptor.service";
import {GlobalVariable} from "./global.vars";
import {Observable} from "rxjs/Observable";

@Injectable()
export class AssetsService {

  private API_URL = GlobalVariable.API_URL;

  constructor (private Http: HttpInterceptor2) {
  }

  getAssets(searchQuery,limit?,page?): Observable<any>{
    let l=10;
    let p= 1;

    if (page) p=page;
    if (limit) l=limit;

    return this.Http.post(this.API_URL+'/fleet/query?limit='+l+'&page='+p,searchQuery)

  }

  getSingleAsset(searchQuery,limit?,page?): Observable<any>{
    let l=10;
    let p= 1;

    if (page) p=page;
    if (limit) l=limit;

    return this.Http.post(this.API_URL+'/asset/query?limit='+l+'&page='+p,searchQuery)

  }

  getAssetsIcons(assets){
    for(let asset of assets){
      asset = this.getSingleAssetIcons(asset);
    }
    return assets;
  }

  getHistoricAssetIcon(asset, status){

    let path = "assets/fleet/";
    let type = "personal_vehicle";
    if(asset) {
      if (asset.type && asset.type._id) {
        type = asset.type._id.replace(" ", "_").toLowerCase();
      }
    }

    return  path + type + "/" + status + "_up.png";
  }

  getSingleAssetIcons(asset){
      let path = "assets/fleet/";
      let type = "personal_vehicle";
      let status = "stop";
      if(asset){
        if(asset.type && asset.type._id) {
          type = asset.type._id.replace(" ", "_").toLowerCase();
        }
      }


      if(asset.rt === undefined){
        status = "disabled";
      }else{
        // Car current stat
        if(asset.rt.io && asset.rt.io.con === 1){
          if( asset.rt.io.spd > 0){
            status = "drive";
          }else{
            status = "idle";
          }
        }


        let now = moment();
        let lastUpdate = moment(asset.rt.gps_dt);
        let difference = now.diff(lastUpdate, 'days');
        if(difference >= 3 ){
          status = "disabled";
        }

      }
      asset.icons = {};
      asset.icons.side = path + type + "/" + status + "_side.png";
      asset.icons.up = path + type + "/" + status + "_up.png";
      asset.icons._3d = path + type + "/" + status + "_3d.png";
        asset.status =status;
    return asset;
  }


}



// WEBPACK FOOTER //
// ./src/services/assets.service.ts